import React from 'react';
import PerspectiveBanner from './PerspectiveBanner/PerspectiveBanner';
import PerspectiveSection from './PerspectiveSection/PerspectiveSection';

function Perspective() {
    return (
        <>
            <PerspectiveBanner />
            <PerspectiveSection />
        </>
    );
}

export default Perspective;